<template>
    <v-dialog
        v-if="showDialog"
        :model-value="exportFactSheetsDialog"
        max-width="400"
        @click:outside="cleanUpAndCloseDialog"
    >
        <v-card>
            <v-card-title class="pt-4">Export fact sheets</v-card-title>
            <v-card-text class="pl-4 pt-0">
                <v-text-field
                    prepend-inner-icon="mdi-export"
                    :model-value="schematisationToExport.name"
                    readonly
                    color="primary"
                    filled
                />
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn
                    :loading="exportFactSheetsLoading"
                    color="primary"
                    text
                    :disabled="exportFactSheetsLoading"
                    @click="onExportFactSheets"
                >
                    Export
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
    name: "SchematisationExportFactSheetDialog",
    computed: {
        ...mapState('stabSchematisation', {
            exportFactSheetsDialog: state => state.exportFactSheetsDialog,
            schematisationToExport: state => state.currentOverviewItem,
            exportFactSheetsLoading: state => state.exportFactSheetsLoading,
        }),
        showDialog() {
            return this.schematisationToExport?.id > 0;
        },
    },
    methods: {
        ...mapActions('stabSchematisation', {
            toggleExportFactSheetsDialog: "toggleExportFactSheetsDialog",
            exportFactSheets: "exportFactSheets",
        }),
        async onExportFactSheets() {
            try {
                await this.exportFactSheets(this.schematisationToExport.id);
            } catch (e) {
                console.log(e);
            } finally {
                await this.cleanUpAndCloseDialog();
            }
        },
        async cleanUpAndCloseDialog() {
            await this.toggleExportFactSheetsDialog();
        },
    },
}
</script>
